export enum TriggerActionTypes {
  INVALID = -1,
  OK,
  CANCEL,
  LOGOUT,
  RELOAD,
  LINK,
}
